import ApiBase from '@/api/api-base'
import { ACTIVE_BASE_REST } from '@/api/constants'

export default class FinancialBonusCoupon extends ApiBase {
  constructor(store) {
    super(store, `${ ACTIVE_BASE_REST }/bonus/coupon`)
  }

  generate(model, showProgress) {
    return this._request({
      action: 'generate',
      method: 'POST',
      body: model,
      showProgress
    })
  }
}
